import styled from 'styled-components';
import type { WithSX } from '@elfsight/lib-utils';
import { applySX } from '@elfsight/lib-utils';
import { widgetTitleDefaultSettings } from './defaultSettings';
import type { WidgetTitleProps } from './types';

export function WidgetTitle({
  enabled = widgetTitleDefaultSettings.widgetTitle,
  title = widgetTitleDefaultSettings.widgetTitleTitle,
  caption = widgetTitleDefaultSettings.widgetTitleCaption,
  titleColor = widgetTitleDefaultSettings.widgetTitleTitleColor,
  captionColor = widgetTitleDefaultSettings.widgetTitleCaptionColor,
  linksColor = widgetTitleDefaultSettings.widgetTitleLinksColor,
  alignment = widgetTitleDefaultSettings.widgetTitleAlignment,
  titleTextStyle = widgetTitleDefaultSettings.widgetTitleTitleTextStyle,
  captionTextStyle = widgetTitleDefaultSettings.widgetTitleCaptionTextStyle,
  enabledTextBalance = widgetTitleDefaultSettings.enabledTextBalance,
  bottomOffset,
  maxWidth,
  ...forwardingProps
}: WidgetTitleProps) {
  if (!enabled || (!title && !caption)) {
    return null;
  }

  return (
    <Container
      $sx={{
        textAlign: alignment,
        marginBottom: bottomOffset || undefined
      }}
      {...forwardingProps}
    >
      <Inner $sx={{ maxWidth: maxWidth || undefined }}>
        {title && (
          <Header
            _linksColor={linksColor}
            $sx={{
              ...titleTextStyle,
              color: titleColor,
              textWrap: enabledTextBalance ? 'balance' : undefined
            }}
            dangerouslySetInnerHTML={{ __html: title }}
          />
        )}
        {caption && (
          <Caption
            _linksColor={linksColor}
            $sx={{
              ...captionTextStyle,
              color: captionColor,
              marginTop: title ? 8 : 0,
              textWrap: enabledTextBalance ? 'balance' : undefined
            }}
            dangerouslySetInnerHTML={{ __html: caption }}
          />
        )}
      </Inner>
    </Container>
  );
}

const Container = styled.div<WithSX>`
  ${applySX};
`;

const Inner = styled.div<WithSX>`
  ${applySX};
  margin: 0 auto;
`;

const Header = styled.div<
  WithSX<{
    _linksColor: string;
  }>
>`
  ${applySX};
  line-height: 1.32;

  & a {
    color: ${({ _linksColor }) => _linksColor || 'inherit'};
    text-decoration: underline;
  }
`;

const Caption = styled.div<
  WithSX<{
    _linksColor: string;
  }>
>`
  ${applySX};
  line-height: 1.4;

  & a {
    color: ${({ _linksColor }) => _linksColor || 'inherit'};
    text-decoration: underline;
  }
`;
